import { useState, useEffect } from "react";
import { Col, Row, Container, Collapse } from "reactstrap";
import "../../../../features2/recommendation/recommendationJozunaView/styles/JozunaViewStyles.css";
import arrowImg from "../../assets/images/JozunaView/arrowImg.png"; // Import the image
import { useLocation, useNavigate } from "react-router-dom";
import VideoImageOverlay from "./../../recommendation_industry_view/components/VideoImage_Overlay";
import NewImage from "../../recommendation_industry_view/components/New_Image";
import { useApi } from "../../../../service/ApiContext";
import strings from "../../../../utils/Strings";
import Loader, { LocalStorage } from "../../../../utils/Utils";
import {
  CourseTopic,
  CourseTopicListResponse,
} from "../../recommendation_industry_view/data/response/Course_Topic_Response";
import RecommendationIndustryViewClient from "../../recommendation_industry_view/data/api_client/Recommendation_IndustryView_Client";
import { NoTopicsFound } from "../../recommendation_industry_view/components/NoRecords_Found";
import BlueVerticalDivider from "../../recommendation_industry_view/components/Blue_Vertical_Divider";
import { recommendationJozunaViewInstance_Store } from "../data/instance_store/Recommendation_JozunaView_Instance";
import { TopicVideoResponse } from "../../recommendation_industry_view/data/response/Topic_Videos_Response";
import CommonUtils from "../../../../utils/Common_Utils";
import Logger from "../../../../utils/Logger";
import { TopicNameTitleTextComponent } from "../../recommendation_industry_view/components/TopicNameTittleText";
import RecommendationViewHeader from "../../../../features2/recommendation/recommendation_industry_view/components/Recommendation_View_Header";
import infoImg from "../../assets/images/infoIcon.png";
import infoImgBlue from "../../assets/images/info 1.png";

import weekIcon from "../../assets/images/weekIcon.png";
import hourIcon from "../../assets/images/workIcon.png";
import calendarIcon from "../../assets/images/scheduleIcon.png";
import bonusIcon from "../../assets/images/bonusIcon.png";
import levelIcon from "../../assets/images/levelIcon.png";
import GreyHorizontalDivider from "../../recommendation_industry_view/components/grey_Horizontal_Divider";
import { Box, MenuItem, Popover } from "@mui/material";
import { RootState } from "../../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { setJozunaSelectedProgram } from "../../vedio-recommendation/data/redux/JozunaDropdown";
import {
  Recommendation,
  videoLandingPageResponse,
} from "../../vedio-recommendation/data/response/VideoLandingPageResponse";
import VideoLandingPageClient from "../../vedio-recommendation/data/api/VideoLandingPageClient";
import { useAlert } from "../../../../components/AlertContextComponent";
import { videolandingPageRequest } from "../../vedio-recommendation/data/request/VideoLandingPageRequest";
import DropDown from "../../assets/images/dropdown.svg";
import { recommendationIndustryViewInstance_Store } from "../../recommendation_industry_view/data/instance_store/Recommendation_IndustryView_Instance";
import dotImg from "../../assets/images/dotIcon.png";
import backArrowImg from "../../assets/images/common/recommand_right-arrow.png";

type VideoLandingPageProps = {
  activeTb: number; // Adjust the type as needed
};
const RecommendationJozunaView: React.FC<VideoLandingPageProps> = ({
  activeTb,
}) => {
  //Initial Method

  // Declarations
  const api = useApi();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { state } = location;
  const [selectedItem, setSelectedItem] = useState<CourseTopic>();
  const [details, setDetails] = useState<TopicVideoResponse>();
  const [openDetailIndex, setOpenDetailIndex] = useState<number | null>(null);
  const [topicduration, setTopicduration] = useState<number>();
  const [topicList, setTopicList] = useState<CourseTopic[]>();
  const [totVideos, setTotVideos] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState<any>(null);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showInfoModalProgramDetails, setShowInfoModalProgramDetails] =
    useState(false);

  const [selectedCourseInfo, setSelectedCourseInfo] = useState<any>(null);
  //Api Calls
  const getCourseTopic = async (courseId: string, programId: string) => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    setLoading(true);
    try {
      const response = await api.get<CourseTopicListResponse>(
        RecommendationIndustryViewClient.getCourseToipcUrl,
        {
          course_id: courseId,
          program_id: programId, // ✅ DIRECT VALUE
          program_category: "Jozuna",
        },
      );

      setTotVideos(response.data.total_videos ?? null);
      setTopicList(response.data.list_topics);
      setTopicduration(response.data.total_duration);

      if (response.data.list_topics?.length > 0) {
        const firstTopic = response.data.list_topics[0];
        setSelectedItem(firstTopic);
        setSelectedTopic(firstTopic);
        getTopicVideos(firstTopic.topic_id, courseId, programId); // pass forward
      } else {
        setSelectedTopic(null);
        setDetails(undefined);
      }
    } catch (error) {
      Logger.error("Error fetching Course Topics:", error);
    } finally {
      setLoading(false);
      Loader.dismissLoading();
    }
  };
  const getTopicVideos = async (
    topicId: string,
    courseId: string,
    programId: string,
  ) => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    setLoading(true);
    try {
      const response = await api.get<TopicVideoResponse>(
        RecommendationIndustryViewClient.getCourseVideoUrl,
        {
          course_id: courseId,
          topic_id: topicId,
          program_id: programId, // ✅ DIRECT VALUE
          program_category: "Jozuna",
        },
      );

      setDetails(response.data);
    } catch (error) {
      Logger.error("Error fetching Course Videos:", error);
    } finally {
      setLoading(false);
      Loader.dismissLoading();
    }
  };
  //Methods
  const handleTopicClick = (topic: CourseTopic) => {
    if (!topic?.topic_id) return;

    getTopicVideos(
      topic.topic_id,
      selectedCourse?.course_id,
      selectedOptionJozuna?.id || selectedOption?.id || "",
    );
  };
  const handleItemClick = async (item: CourseTopic, isNullOpen: boolean) => {
    console.log("Clicked topic:", item); // ✅ debug

    setSelectedItem(item); // ✅ direct update (no store delay)
    setSelectedTopic(item);

    // ❗ Pass full item (or ensure id exists)
    if (!item?.topic_id) {
      console.error("topic_id missing!", item);
      return;
    }

    handleTopicClick(item); // ✅ pass full object

    if (isNullOpen) {
      recommendationJozunaViewInstance_Store.setOpenedIndex(null);
      setOpenDetailIndex(null);
    }
  };
  const { showAlert } = useAlert();
  const [programOptionsJozuna, setProgramOptionsJozuna] = useState<
    { id: string; title: string; description: string }[]
  >([]);
  const [activeTab, setActiveTab] = useState(activeTb);
  const [loading, setLoading] = useState(false);
  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const selectedProgram = useSelector(
    (state: RootState) => state.JozunaDropdown.JozunaSelectedProgram,
  );
  const [selectedOptionJozuna, setSelectedOptionJozuna] = useState<{
    id: string;
    title: string;
    description: string;
  } | null>(null);
  const [programOptions, setProgramOptions] = useState<
    { id: string; title: string; description: string }[]
  >([]);
  const [selectedOption, setSelectedOption] = useState<{
    id: string;
    title: string;
    description: string;
  } | null>(null);
  const [assessmentFound, setAssessmentFound] = useState(false);
  const [cardData, setCardData] = useState<Recommendation[] | null>(null);
  const [jozunaRecommendation, setJozunaRecommendation] = useState<string>("");
  const [industry, setIndustryData] = useState<Recommendation[] | null>(null);
  const [industryDuration, setIndustryDuration] = useState(0);
  const [jozunaDuration, setJozunaDuration] = useState(0);
  const [selectedId, setSelectedId] = useState("");
  const [selectedDesc, setSelectedDesc] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [Apptoken, setAppToken] = useState<string | null>(null);

  const handleClose2 = () => {
    setAnchorEl2(null);
  };
  // Select the data from the Redux store
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const handleClickDrop = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl2(event.currentTarget);
  };
  const getProgram = async () => {
    Loader.showLoading("Loading...");
    setLoading(true);

    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    const param = {
      domain_name: activeTab === 0 ? "Jozuna" : "Industry",
      offset_time: "+5:30",
    };

    try {
      const response = await api.get<any>("/assessment/names", param);

      // Dispatch programs to Redux store
      Logger.info("response for details", response.data);

      // Map program data to options
      const options = response.data.assessment_names.map((program: any) => ({
        id: program.assessment_entity_id,
        title: program.assessment_name,
        // description: program.program_description,
      }));

      if (options.length === 0) return;

      // ✅ Always pick first option if nothing selected
      // const defaultOption = selectedProgram ?? options[0];

      // get assessment_id from route state
      const stateAssessmentId = state?.assessment_id;

      // try to match assessment_entity_id from API
      const matchedOption = stateAssessmentId
        ? options.find((opt: { id: any }) => opt.id === stateAssessmentId)
        : null;

      // final default selection

      // 1️⃣ Try Redux
      const reduxMatch = selectedProgram
        ? options.find((opt: { id: any }) => opt.id === selectedProgram.id)
        : null;

      // 2️⃣ Try route state
      const routeMatch = stateAssessmentId
        ? options.find((opt: { id: any }) => opt.id === stateAssessmentId)
        : null;

      // 3️⃣ Final fallback
      const defaultOption = reduxMatch ?? routeMatch ?? options[0];

      // // Set options based on activeTab
      // if (activeTab === 0) {
      //   setProgramOptionsJozuna(options);
      // } else {
      //   setProgramOptions(options);
      // }

      if (activeTab === 0) {
        setProgramOptionsJozuna(options);
        setSelectedOptionJozuna(defaultOption);
      } else {
        setProgramOptions(options);
        setSelectedOption(defaultOption);
      }

      dispatch(setJozunaSelectedProgram(defaultOption));
      Logger.info("defaultOption", defaultOption);
      getCourseDetail(activeTab, defaultOption.id);

      // // Find the active program
      // const activeProgram =
      //   response.data.assessment_names.find(
      //     (program: any) => program.status === "Active"
      //   ) || response.data.programs[0];

      // if (activeProgram) {
      //   const selectedOption = {
      //     id: selectedProgram?.id,
      //     title: selectedProgram?.description,
      //     description: selectedProgram?.title,
      //   };

      //   const id = selectedProgram?.id;
      //   const desc = selectedProgram?.description;
      //   setSelectedDesc(desc);

      //   Logger.info("idd", id);

      //   // Set selected option based on activeTab
      //   if (activeTab === 0) {
      //     setSelectedOptionJozuna(selectedOption);
      //   } else {
      //     setSelectedOption(selectedOption);
      //     setSelectedId(id);
      //   }

      //   Logger.info("Selected Options:", selectedOption);
      //   Logger.info("Selected Options id:", selectedId);

      //   Logger.info("Selected Jozuna Options:", selectedOptionJozuna);

      //   // if (!selectedProgram) {
      //   //   dispatch(setJozunaSelectedProgram(selectedOption));
      //   // }

      //   // // Call getEvents only after setting selectedOption
      //   // getCourseDetail(activeTab, id);

      //   if (!selectedProgram) {
      //     console.log("first options");
      //     const firstOption = options[0]; // Select the first program by default
      //     setSelectedDesc(firstOption.description);
      //     if (activeTab === 0) {
      //       setSelectedOptionJozuna(firstOption);
      //     } else {
      //       setSelectedOption(firstOption);
      //     }
      //     dispatch(setJozunaSelectedProgram(firstOption)); // Dispatch to Redux
      //     getCourseDetail(activeTab, firstOption.id); // Load the corresponding course
      //   } else {
      //     getCourseDetail(activeTab, id);
      //   }
      // }
    } catch (error) {
      Logger.info("error response", error);
      // Display an error alert or message if needed
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }
  };
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  useEffect(() => {
    const tokenFromURL = query.get("token");
    const regionFromURL = query.get("region");
    // Handling token
    if (tokenFromURL) {
      Logger.info("Token successfully retrieved from URL:", tokenFromURL);
      LocalStorage.setLocalData("access_token", tokenFromURL); // Store token in local storage
      LocalStorage.setLocalData("fromFlutter", "true");
    } else {
      Logger.info("No token found in URL. Using appToken:");
      const storedToken = LocalStorage.getLocalData("access_token");
      Logger.info(
        "No token found in URL. Using appToken**************:",
        storedToken,
      );

      if (storedToken) {
        setAppToken(storedToken); // Use the token from local storage if not found in URL
        LocalStorage.setLocalData("access_token", storedToken);
      }
    }

    // Handling region
    if (regionFromURL) {
      Logger.info("Region successfully retrieved from URL:", regionFromURL);
      LocalStorage.setLocalData("region", regionFromURL); // Store region in local storage
      LocalStorage.setLocalData("fromFlutter", "true");
    } else {
      Logger.info("No region found in URL.");
    }
    // Check if data for the current tab has already been loaded
    if (
      (activeTab === 0 && jozunaRecommendation !== "jozuna") ||
      (activeTab === 1 && !industry)
    ) {
      getProgram();
    }
    return () => {
      recommendationIndustryViewInstance_Store.clearState(); //Clean Up Recommendation Industry View SelectedItem
      recommendationJozunaViewInstance_Store.clearState(); //Clean Up Recommendation Jozuna View SelectedItem
    };
  }, [activeTab, jozunaRecommendation, industry]);
  const handleOptionChange = (
    option: {
      id: string;
      title: string;
      description: string;
    },
    tab: number,
  ) => {
    if (tab === 0) {
      setSelectedOptionJozuna(option);
      // dispatch(setJozunaSelectedProgram(option));
      Logger.info("option", selectedProgram);
    }
    if (tab === 1) {
      setSelectedOption(option);
      // dispatch(setSelectedOptions(option)); // Redux action for other tabs
      // dispatch(setJozunaSelectedProgram(option));
    }
    setSelectedId(option.id);
    getCourseDetail(activeTab, option.id);
    setSelectedDesc(option.description);
    setAnchorEl2(null);
    Logger.info("selected option", selectedOption);
    Logger.info("selected Idd", selectedId);
    dispatch(setJozunaSelectedProgram(option)); // Save the selected program to Redux
    setIsOpen(false);
  };
  const getCourseDetail = async (tab: number, id: string) => {
    Loader.showLoading("Loading...");
    setLoading(true);
    const param: videolandingPageRequest = {
      recommendation_type: tab == 0 ? "Jozuna" : "Industry",
      program_id: id,
    };
    Logger.info("param", param);
    Logger.info("Selected options", selectedOption?.title);

    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<videoLandingPageResponse>(
        VideoLandingPageClient.landingPageURL,
        param,
      );
      Logger.info("response", response.data);
      if (response.data.error != null) {
        showAlert({
          show: true,
          title: "Error",
          message: response.data.error,
          button1Text: "Cancel",
          alertType: "error",
          onlyNeedOneButton: true,
          btn1onPressed: () => {
            ("");
          },
        });
      } else if (
        response.data.recommendation.length === 0 &&
        response.data.error == null
      ) {
        setAssessmentFound(true);
      } else {
        setAssessmentFound(false);
      }
      const courseData = response.data.recommendation || [];
      const type = response.data.recommendation_type.toLowerCase();
      const sortedCourseData = courseData.sort(
        (a, b) => a.seq_number - b.seq_number,
      );
      // Sort the courseData immediately before setting it to state
      if (type === "industry") {
        setIndustryData(sortedCourseData);
        setIndustryDuration(response.data.total_duration);
      } else if (type === "jozuna") {
        setJozunaDuration(response.data.total_duration);
        setCardData(sortedCourseData);
        setJozunaRecommendation("jozuna");
      }
      // ✅ AUTO SELECT FIRST COURSE
      if (sortedCourseData.length > 0) {
        const firstCourse = sortedCourseData[0];

        setSelectedCourse(firstCourse);

        // ✅ PASS programId directly
        getCourseTopic(firstCourse.course_id, id);
      }
    } catch (error) {
      Logger.info("error response", error);
      if (activeTab == 1) {
        setIndustryData([]);
        setIndustryDuration(0);
      } else {
        setJozunaDuration(0);
        setCardData([]);
      }
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }
  };
  const [selectedCourse, setSelectedCourse] = useState<any>(null);

  const handleCourseClick = (course: any) => {
    setSelectedCourse(course);
    getCourseTopic(
      course.course_id,
      selectedOptionJozuna?.id || selectedOption?.id || "",
    ); // safe after load
  };
  const toggleDetail = (index: number) => {
    if (openDetailIndex === index) {
      recommendationJozunaViewInstance_Store.setOpenedIndex(null);
      setOpenDetailIndex(
        recommendationJozunaViewInstance_Store.getOpenedIndex()!,
      );
    } else {
      recommendationJozunaViewInstance_Store.setOpenedIndex(index);
      setOpenDetailIndex(
        recommendationJozunaViewInstance_Store.getOpenedIndex()!,
      );
    }
  };
  const active = 0;
  return (
    <div
      style={{
        height:
          LocalStorage.getLocalData("fromFlutter") !== "true"
            ? "90vh"
            : "100vh",
        // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      {" "}
      {/* <GreyHorizontalDivider /> */}
      <div style={{ backgroundColor: "transparent", height: "100%" }}>
        {/* <Container fluid> */}
        <header>
          <div
            className="header-container"
            style={{
              boxShadow: "none",
              paddingLeft: "30px",
              paddingRight: "10px",
            }}
          >
            <div className="home-section">
              {location.pathname ===
                "/dashboard/recommendation/jozunaview/video" && (
                <img
                  src={backArrowImg}
                  alt="Back"
                  style={{
                    width: "24px",
                    height: "24px",
                    marginRight: "8px",
                    cursor: "pointer",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    navigate("/dashboard/recommendation", {
                      state: { active },
                    });
                  }}
                />
              )}
              <div>
                <span
                  style={{ marginLeft: "0px", color: "#344054" }}
                  className="home-text"
                >
                  {activeTab === 0
                    ? selectedOptionJozuna?.title
                    : selectedOption?.title}
                </span>{" "}
                <span
                  style={{
                    cursor: "pointer",
                    marginLeft: "10px",
                    fontSize: "14px",
                    fontWeight: 300,
                    fontFamily: "Mazzard",
                    color: "#099ef1",
                  }}
                  onClick={() => {
                    setShowInfoModalProgramDetails(true);
                  }}
                >
                  View details <img src={infoImgBlue} />
                </span>
                <div
                  style={{
                    marginLeft: "0px",
                    color: "#344054",
                    fontSize: "14px",
                    fontWeight: 300,
                  }}
                  className="home-text"
                >
                  Develop yourself into a career ready dynamic personality with
                  your personalized learning outcomes{" "}
                </div>
              </div>
            </div>
            <div
              className="program-dropdown"
              style={{ justifyContent: "flex-end", marginRight: "20px" }}
            >
              {/* <div className="program-dropdown-text">Assessments :</div> */}
              <div className="dropdown">
                <div
                  className="program-dropdown-container"
                  onClick={handleClickDrop}
                >
                  <span className="program-name">
                    {activeTab === 0
                      ? selectedProgram?.title || "Jozuna"
                      : selectedOption?.title || "Jozuna"}
                  </span>

                  <button className="change-btn">
                    <span>Change</span>
                    <span className="change-arrow">▼</span>
                  </button>
                </div>
                <Popover
                  open={Boolean(anchorEl2)}
                  anchorEl={anchorEl2}
                  onClose={handleClose2}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                  PaperProps={{
                    style: {
                      width: "300px",
                      marginTop: "5px",
                      borderRadius: "10px",
                      backgroundColor: "#ffffff",
                      boxShadow: "#00000040",
                      padding: "8px 8px",
                    },
                  }}
                >
                  <Box sx={{ padding: "0px" }}>
                    {activeTab === 0 ? (
                      programOptionsJozuna.length > 0 ? (
                        programOptionsJozuna.map((option) => (
                          <MenuItem
                            key={option.id}
                            onClick={() => {
                              handleOptionChange(option, activeTab); // Update local state or perform actions
                              // dispatch(setJozunaSelectedProgram(option)); // Dispatch Redux action
                            }}
                            style={{
                              fontFamily: "Mazzard",
                              color: "#242730",
                              fontSize: "16px",
                              fontWeight: "500",
                            }}
                          >
                            <span className="option-label-rec">
                              {option.title}
                            </span>
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>No programs found</MenuItem>
                      )
                    ) : programOptions.length > 0 ? (
                      programOptions.map((option) => (
                        <MenuItem
                          key={option.id}
                          onClick={() => {
                            handleOptionChange(option, activeTab); // Update local state or perform actions
                            dispatch(setJozunaSelectedProgram(option)); // Dispatch Redux action
                          }}
                          style={{
                            fontFamily: "Mazzard",
                            color: "#242730",
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          <span
                            style={{
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                              maxWidth: "100%", // Ensure it stays within the MenuItem width
                            }}
                            className="option-label-rec"
                          >
                            {option.title}
                          </span>
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No programs found</MenuItem>
                    )}
                  </Box>
                </Popover>
              </div>
            </div>
            {/* <img
  src={quesIcon} // put your image path here
  alt="Recommendations"
  style={{
    width: "40px",
    height: "40px", // adjust size as needed
    marginRight: "",
    cursor: "pointer",
  }}
                 onClick={()=>{toggleModal()}}

/> */}
          </div>
        </header>
        {/* <RightModalRecommendation
                  isOpen={isModalOpen}
                  toggleModal={toggleModal}
                /> */}
        {/* </Container> */}
        {/* <br></br> */}

        <Row style={{ margin: "15px" }}>
          <div className="Reco_v2-course-card-container">
            {cardData && cardData.length > 0 ? (
              cardData.map((item) => (
                <div
                  key={item.course_id}
                  className={`Reco_v2-course-card ${
                    item.completion_status === "Completed"
                      ? "Reco_v2-course-card-completed"
                      : item.completion_status === "In Progress"
                        ? "Reco_v2-course-card-inprogress"
                        : "Reco_v2-course-card-notStarted"
                  }`}
                  onClick={() => handleCourseClick(item)}
                >
                  <div className="Reco_v2-course-image-container">
                    <img
                      src={item.course_thumbnail}
                      alt={item.course_title}
                      className="Reco_v2-course-image"
                    />

                    <div
                      className="Reco_v2-info-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedCourseInfo(item);
                        setShowInfoModal(true);
                      }}
                    >
                      <img src={infoImg} alt="Info" />
                    </div>
                  </div>

                  <div className="Reco_v2-course-body">
                    <div className="Reco_v2-course-title-row">
                      <h3>{item.course_title}</h3>

                      {item.is_new && (
                        <span className="Reco_v2-new-badge">NEW</span>
                      )}
                    </div>

                    <p className="Reco_v2-course-description">
                      {item.course_description}
                    </p>

                    <div className="Reco_v2-course-meta">
                      <span>• {item.total_videos} Videos</span>
                      <span>• {item.total_files} Documents</span>
                    </div>
                  </div>

                  <button
                    className={`Reco_v2-status-btn ${
                      item.completion_status === "Completed"
                        ? "Reco_v2-completed"
                        : item.completion_status === "In Progress"
                          ? "Reco_v2-progress"
                          : "Reco_v2-not-started"
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/dashboard/recommendation/jozunaview/course", {
                        state: {
                          courseId: item.course_id,
                          course_name: item.course_title,
                          programId:
                            selectedOptionJozuna?.id ||
                            selectedOption?.id ||
                            "",
                          programName:
                            selectedOptionJozuna?.title ||
                            selectedOption?.title ||
                            "",
                        },
                      });
                    }}
                  >
                    {item.completion_status}
                  </button>
                </div>
              ))
            ) : (
              <div
                style={{
                  gridColumn: "1 / -1",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "300px",
                  fontSize: "18px",
                  color: "#667085",
                  fontWeight: 500,
                }}
              >
                No Data Found
              </div>
            )}
          </div>
        </Row>
      </div>
      {showInfoModal && selectedOptionJozuna?.id && (
        <div className="recommendation-info-overlay">
          <div
            className="recommendation-info-modal"
            style={{
              background: "#fff",
              borderRadius: "20px",
              padding: "24px",
              width: "900px",
              maxWidth: "95%",
            }}
          >
            {/* Header */}
            <div className="recommendation-info-header">
              <h3>Phase Information</h3>
              <button
                className="recommendation-info-close"
                onClick={() => setShowInfoModal(false)}
              >
                ✕
              </button>{" "}
            </div>

            <GreyHorizontalDivider />

            <br />

            {/* Body */}
            <div
              style={{
                display: "flex",
                gap: "28px",
                alignItems: "flex-start",
              }}
            >
              {/* Left Image */}
              <img
                src={selectedCourseInfo.course_thumbnail}
                alt="thumbnail"
                style={{
                  width: "500px",
                  height: "280px",
                  borderRadius: "20px",
                  objectFit: "cover",
                  flexShrink: 0,
                }}
              />

              {/* Right Content */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  flex: 1,
                }}
              >
                <h2
                  style={{
                    fontSize: "30px",
                    fontWeight: 600,
                    color: "#2d2d2d",
                    fontFamily: "Mazzard",
                    marginBottom: "14px",
                  }}
                >
                  {selectedCourseInfo.course_title}
                </h2>

                <p
                  style={{
                    fontSize: "20px",
                    color: "#2d2d2d",
                    fontFamily: "Mazzard",
                    fontWeight: 400,
                    textAlign: "justify",
                    marginBottom: "10px",
                  }}
                >
                  {selectedCourseInfo.course_description}
                </p>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    fontSize: "18px",
                    color: "#667085",
                  }}
                >
                  <span>• {selectedCourseInfo.total_videos} Videos</span>

                  <span>• {selectedCourseInfo.total_files} Documents</span>

                  {selectedCourseInfo.is_new && (
                    <span
                      style={{
                        background: "#FF1D1D",
                        color: "#fff",
                        fontSize: "12px",
                        fontWeight: 600,
                        padding: "3px 8px",
                        borderRadius: "4px",
                      }}
                    >
                      NEW
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showInfoModalProgramDetails && (
        <div className="recommendation-info-overlay">
          <div
            className="recommendation-info-modal"
            style={{
              background: "#fff",
              borderRadius: "20px",
              padding: "24px",
              // width: "900px",
              maxWidth: "85%",
            }}
          >
            {/* Header */}
            <div className="recommendation-info-header">
              <p
                style={{
                  margin: 0,
                  fontSize: "20px",
                  fontWeight: 600,
                  fontFamily: "Mazzard",
                  color: "#344054",
                }}
              >
                {selectedOptionJozuna?.title}
              </p>
              <button
                className="recommendation-info-close"
                onClick={() => setShowInfoModalProgramDetails(false)}
              >
                ✕
              </button>{" "}
            </div>

            <GreyHorizontalDivider />
            {/* Body */}
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                flexDirection: "column",
                gap: "24px",
              }}
            >
              {/* Program Title */}
              <div>
                {/* <h2
                  style={{
                    margin: 0,
                    fontSize: "30px",
                    fontWeight: 600,
                    fontFamily: "Mazzard",
                    color: "#344054",
                  }}
                >
                  {selectedOptionJozuna?.title}
                </h2> */}

                <p
                  style={{
                    marginTop: "0px",
                    fontSize: "15px",
                    color: "#475467",
                    fontFamily: "Mazzard",
                    maxWidth: "90%",
                  }}
                >
                  {
                    "Develop yourself into a career ready dynamic personality with your personalized learning outcomes"
                  }
                </p>
              </div>
              {/* Info Cards */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "16px",
                  marginTop: "-20px",
                }}
              >
                {/* Weeks */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    background: "#EEF4FF",
                    fontFamily: "Mazzard",
                    borderRadius: "16px",
                    padding: "10px",
                  }}
                >
                  <img
                    src={weekIcon}
                    alt=""
                    style={{ width: "32px", height: "32px" }}
                  />
                  <span
                    style={{
                      fontFamily: "Mazzard",
                      fontSize: "16px",
                      color: "#344054",
                    }}
                  >
                    {4} Weeks Course Series
                  </span>
                </div>

                {/* Level */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    background: "#EEF4FF",
                    borderRadius: "16px",
                    padding: "10px",
                  }}
                >
                  <img
                    src={levelIcon}
                    alt=""
                    style={{ width: "32px", height: "32px" }}
                  />
                  <span
                    style={{
                      fontFamily: "Mazzard",
                      fontSize: "16px",
                      color: "#344054",
                    }}
                  >
                    {"Beginner Level"}
                  </span>
                </div>

                {/* Bonus */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    background: "#EEF4FF",
                    borderRadius: "16px",
                    padding: "10px",
                  }}
                >
                  <img
                    src={bonusIcon}
                    alt=""
                    style={{ width: "32px", height: "32px" }}
                  />
                  <span
                    style={{
                      fontFamily: "Mazzard",
                      fontSize: "16px",
                      color: "#344054",
                    }}
                  >
                    1 Bonus Challenge
                  </span>
                </div>

                {/* Hours */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    background: "#EEF4FF",
                    borderRadius: "16px",
                    padding: "10px",
                  }}
                >
                  <img
                    src={hourIcon}
                    alt=""
                    style={{ width: "32px", height: "32px" }}
                  />
                  <span
                    style={{
                      fontFamily: "Mazzard",
                      fontSize: "16px",
                      color: "#344054",
                    }}
                  >
                    3.5 Hours Content{" "}
                  </span>
                </div>

                {/* Schedule */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    background: "#EEF4FF",
                    borderRadius: "16px",
                    padding: "10px",
                    width: "100%",
                  }}
                >
                  <img
                    src={calendarIcon}
                    alt=""
                    style={{ width: "32px", height: "32px" }}
                  />
                  <span
                    style={{
                      fontFamily: "Mazzard",
                      fontSize: "16px",
                      color: "#344054",
                    }}
                  >
                    Flexible Schedule{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecommendationJozunaView;
